export default __webpack_public_path__ + "static/media/people12.71f2d4de.jpeg";